import { combineReducers, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { configuration, savedConfigurationReducer } from './features/configuration-management/ducks';
import { exportReducer } from './features/export/ducks';
import { accessoriesReducer } from './features/get-accessories/ducks';
import { moduleActionsReducer } from './features/get-module-actions/ducks';
import { getQuestionsReducer } from './features/question-management/ducks';
import {
  getHeadModulesReducer, getCompatibleModulesReducer,
  getReplaceableModulesReducer, getInsertableModulesReducer,
  getCompatibleIslandModulesReducer, getCompatibleIslandBCReducer,
  getReplaceableHeadReducer,
  getPacdriveKitsReducer
} from './features/get-modules/ducks';
import { getSavedConfigurationsReducer, shouldHandleConfigurationRestore, showButtonAnimations } from './features/screens/start_configuration_screen/ducks';
import { modal } from './features/modals/ducks';
import { createSessionReducer } from './features/screens/ducks';
import { descriptionCacheReducer } from './persistence/description-cache/ducks';
import { documentationReducer, cadReducer, datasheetReducer } from './features/documentation-management/ducks';
import { notificationReducer } from './features/notification/ducks';
import { applicationParametersReducer } from './utils/application-parameters/ducks';
import { shouldHandleDefaultSearchParameters } from './features/screens/head_device_selector_screen/ducks';
import { mySchneiderCountriesReducer } from './features/get-my-schneider-countries/ducks';
import { powerSuppliesReducer } from './features/get-power-supplies/ducks';
import { racksReducer } from './features/get-racks/ducks';
import { hmcCategoriesReducer } from './features/get-hmc-categories/ducks';
import { callByRangeReducer } from './features/call-by-range/ducks';
import { getSurveyReducer } from './features/survey-management/ducks';
import { getProductsAvailabilityReducer } from './features/product-availability-information/ducks';

const rootReducer = combineReducers({
  accessories: accessoriesReducer,
  applicationParameters: applicationParametersReducer,
  configuration,
  cadReducer,
  datasheetReducer,
  callByRangeReducer,
  createSession: createSessionReducer,
  compatibleModules: getCompatibleModulesReducer,
  compatibleIslandModules: getCompatibleIslandModulesReducer,
  descriptionCache: descriptionCacheReducer,
  documentationReducer,
  export: exportReducer,
  headModules: getHeadModulesReducer,
  hmcCategories: hmcCategoriesReducer,
  moduleActions: moduleActionsReducer,
  pacdriveKits: getPacdriveKitsReducer,
  powerSupplies: powerSuppliesReducer,
  racks: racksReducer,
  questions: getQuestionsReducer,
  replaceableModules: getReplaceableModulesReducer,
  replaceableHead: getReplaceableHeadReducer,
  insertableModules: getInsertableModulesReducer,
  compatibleIslandBC: getCompatibleIslandBCReducer,
  savedConfigurations: getSavedConfigurationsReducer,
  configurationSaver: savedConfigurationReducer,
  modal,
  mySchneiderCountries: mySchneiderCountriesReducer,
  notification: notificationReducer,
  shouldHandleConfigurationRestore,
  shouldHandleDefaultSearchParameters,
  survey: getSurveyReducer,
  showButtonAnimations,
  productsAvailability: getProductsAvailabilityReducer
});

export default createStore(
  rootReducer,
  applyMiddleware(thunk));
